function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.75 25C26.9688 25 28 24.0156 28 22.75V9.25C28 8.03125 26.9688 7 25.75 7H6.25C4.98438 7 4 8.03125 4 9.25V22.75C4 24.0156 4.98438 25 6.25 25H25.75ZM9.25 9.625C10.6562 9.625 11.875 10.8438 11.875 12.25C11.875 13.7031 10.6562 14.875 9.25 14.875C7.79688 14.875 6.625 13.7031 6.625 12.25C6.625 10.8438 7.79688 9.625 9.25 9.625ZM7 22V19.75L10.3281 16.4219C10.5625 16.1875 10.8906 16.1875 11.125 16.4219L13.75 19L20.0781 12.6719C20.3125 12.4375 20.6406 12.4375 20.875 12.6719L25 16.75V22H7Z",
  fill: "#D5D7DE"
});

var SvgPhoto = function SvgPhoto(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo.5f81e6bc.svg";
export { ForwardRef as ReactComponent };